<template>
  <form novalidate @submit.prevent="onConfirm">
    <LsModal title="Custom bed size" track-id="bed_size_custom_modal">
      <template #body>
        <div class="bed-size-custom-modal--container">
          <div class="bed-size-custom-modal--input">
            <LsInputFt
              v-model="length"
              label="Specify length"
              name="length"
              track-id="bed_size_custom_modal-length"
              placeholder="e.g. 15"
              :validation="{ required: true }"
            />
          </div>
          <div class="bed-size-custom-modal--input">
            <LsInputFt
              v-model="width"
              label="Specify width"
              name="width"
              track-id="bed_size_custom_modal-width"
              placeholder="e.g. 20"
              :validation="{ required: true }"
            />
          </div>
        </div>
      </template>
      <template #footer>
        <LsButton track-id="bed_size_custom_modal-confirm" text="confirm" type="submit" />
      </template>
    </LsModal>
  </form>
</template>

<script>
import { LsModal, LsInputFt, LsButton } from '@/components/common';
import VueTypes from 'vue-types';

export default {
  name: 'BedSizeCustomModal',
  components: {
    LsModal,
    LsInputFt,
    LsButton,
  },
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    setCustomBedSize: VueTypes.func.isRequired,
  },
  data() {
    return {
      width: '',
      length: '',
    };
  },
  methods: {
    async onConfirm() {
      const valid = await this.$validator.validateAll();
      if (!valid) {
        return;
      }
      this.setCustomBedSize({ length: this.length, width: this.width });
      this.$parent.close();
    },
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: $desktop) {
  .bed-size-custom-modal--input {
    width: 200px;
  }
  .bed-size-custom-modal--container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}
</style>
